export enum ReportPdfType {
  PriorReport = 1,
  Preview = 2,
  FinalReport = 3,
  FinalWordDocument = 4,
}
